
require('../../static/css/reset.css');
require('../../sass/common/reset.scss');

require('../../common/layout/header/header').run('noLogin');
require('../../common/layout/footer/footer').run();

require('../../sass/common/footer_link_html.scss');
require('../../sass/help/help.scss');


$(document).ready(function(){
    $(".hotelNote-item").on("click",function(){
        $(this).siblings().removeClass('current');
        $(this).addClass('current');
        
        $('.aboutUsWrap').addClass('hidden');
        $('.aboutUsWrap[data-for="' + $(this).attr('id') + '"]').removeClass('hidden');
    });
    
    let queryString = require('../../common/util').queryString;
    
    if (queryString('id')){
        $(".hotelNote-item[id='" + queryString('id') + "']").trigger('click');
    }
    
});


// WEBPACK FOOTER //
// ./src/js/help/help.js